import React from 'react';

import { flagStyles } from '../settings';

const SvgPN = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4296px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPN;
